import request from 'src/utils/request';
// import { response } from 'express'

export const getUsers = (params: any) =>
  request({
    url: '/users',
    method: 'get',
    params,
  }).then(response => response.data);

export const getUserInfo = (data: any) =>
  request({
    url: '/users/info',
    method: 'post',
    data,
  }).then(response => response.data);

export const getUserByName = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'get',
  }).then(response => response.data);

export const updateUser = (username: string, data: any) =>
  request({
    url: `/users/${username}`,
    method: 'put',
    data,
  }).then(response => response.data);

export const deleteUser = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'delete',
  }).then(response => response.data);

export const localLogin = (data: any) => {
  return request({
    url: '/member/auth/login',
    method: 'post',
    data,
  }).then(response => response);
};

export const verifyLocalLogin = (data: any) => {
  return request({
    url: '/member/auth/verify-login',
    method: 'post',
    data,
    // baseURL: process.env.REACT_APP_API_URL,
  }).then(response => response);
};

export const logout = (data: any) =>
  request
    .get('/member/auth/logout', data)
    .then(response => response);

export const register = (data: any) =>
  request({
    url: '/users/register',
    method: 'post',
    data,
  }).then(response => response.data);
